export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q03_a.bf004b18.png";